<form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
  <h2 mat-dialog-title i18n="@@shared.editarea">Edit area size</h2>
  @if (isLoading()) {
    <app-loader containerClass="on-dialog"></app-loader>
  } @else {
    <mat-dialog-content>
      <p>
        {{ translations.dialogContent }}
      </p>
      <div class="row-container">
        <div class="row row-2">
          <div class="item">
            <app-input-select
              [label]="translations.unit"
              formControlName="type"
              [options]="areaUnitTypeOptions"
            ></app-input-select>
          </div>
          <div class="item">
            <app-input
              [label]="translations.valueLabel"
              formControlName="value"
              type="number"
            ></app-input>
            @if (hints && formGroup.valid) {
              <div class="hints">
                @for (hint of hints; track hint.label) {
                  <mat-hint>{{ hint.label }}: {{ hint.value | number }}</mat-hint>
                  <br />
                }
              </div>
            }
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <app-button-group>
        <app-button (pressed)="onClose()" type="ghost" i18n="@@action.cancel">Cancel</app-button>
        <app-button
          [disabled]="isSubmitButtonDisabled()"
          accessibilityRole="submit"
          cdkFocusInitial
        >
          <mat-icon icon-left>check</mat-icon>
          <ng-container i18n="@@action.save">Save</ng-container>
        </app-button>
      </app-button-group>
    </mat-dialog-actions>
  }
</form>
